<template>
  <!-- :style="codeshow?'cursor:no-drop':''" -->
  <div class="landingpage">
    <div class="landingpage_register">
      <div class="landingpage_register_box">
        <div class="landingpage_register_img">
          <div class="landingpage_register_img1">
            <img src="../assets/antdiylogo.svg" alt="" />
          </div>
          <div class="landingpage_register_img2">
            <img src="../assets/land2.svg" alt="" />
          </div>
        </div>
        <div class="landingpage_register_center">
          <div class="landingpage_register_title">Get your most profitable</div>
          <div class="landingpage_register_title">
            AilExpress Dropshipping business now!
          </div>
          <form action="" ref="formcheck" class="landingpage_form">
            <div class="landingpage_register_div">
              <input
                @input="checkEmail"
                v-model="mailtext"
                type="text"
                placeholder="Email"
                class="landingpage_register_content1"
                :disabled="codeshow2"
                :style="codeshow2 ? 'cursor:no-drop' : ''"
              />
              <div id="landingpage_register_email">
                {{ emailvalue }}
              </div>
            </div>
            <div class="landingpage_register_code">
              <div class="landingpage_register_div2">
                <input
                  @input="checkcode"
                  v-model="mailtext2"
                  type="text"
                  placeholder="Verification Code"
                  class="landingpage_register_content2"
                />
                <div id="landingpage_register_email2">
                  {{ emailvalue2 }}
                </div>
                 <div id="landingpage_register_email2" v-if="codebox==true">
                  {{ codeerror }}
                </div>
              </div>
              
              <button
                class="landingpage_register_content2_button"
                @click="getcode"
                v-if="codeshow"
                :disabled="!visible"
                :style="!visible ? 'cursor:no-drop' : ''"
              >
                Get Code
              </button>
              <div
                class="landingpage_register_content2_button"
                @mouseenter="mouseentera"
                @mouseleave="mouseleavea"
                v-if="codeshow2"
              >
                {{ this.yztime + "s" }}
                <div
                ref="banner"
                id="landingpage_register_banner"
                v-if="codeshow3"
              >
                Didn't get it? Check your spam folder.
              </div>
              <div class="landingpage_register_banner2" v-if="codeshow3"></div>
              </div>
            </div>
            <div class="landingpage_register_div3">
              <input
                type="text"
                @input="checkpassword"
                v-model="mailtext3"
                placeholder="Password"
                class="landingpage_register_content3"
              />
              <div id="landingpage_register_email3">
                {{ emailvalue3 }}
              </div>
            </div>
            <div class="landingpage_register_content4" @click="handleSubmit">
              Sign up for free
            </div>
            <div class="landingpage_register_content5">
              By clicking Sign Up, you agree to our
              <a
                :href="'https://www.antdiy.vip/detail?p=3&source=' + source"
                class="landingpage_a"
                target="_blank"
                >Terms of Service</a
              >
              and
              <a
                :href="'https://www.antdiy.vip/detail?p=3&source=' + source"
                class="landingpage_a"
                target="_blank"
                >Privacy Policy.</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="landingpage_drop">
      <div class="landingpage_drop_box">
        <div class="landingpage_drop_title">
          Get ready to earn with AliExpress dropshipping!
        </div>
        <div class="landingpage_drop_content">
          <div class="landingpage_drop_div">
            <div class="landingpage_drop_font">100000+</div>
            <div class="landingpage_drop_font2">Merchants Trusted Us</div>
          </div>
          <div class="landingpage_drop_div">
            <div class="landingpage_drop_font">90K+</div>
            <div class="landingpage_drop_font2">Orders Delivered</div>
          </div>
          <div class="landingpage_drop_div2">
            <div class="landingpage_drop_font">20M+</div>
            <div class="landingpage_drop_font2">Trusted Suppliers</div>
          </div>
          <div class="landingpage_drop_div2">
            <div class="landingpage_drop_font">100M+</div>
            <div class="landingpage_drop_font2">Products Available</div>
          </div>
        </div>
      </div>
    </div>
    <div class="landingpage_img">
      <div class="landingpage_img_url" ></div>
       <div class="landingpage_img_url2" ></div>
      <div class="landingpage_img_box">
        <div class="landingpage_img_title">How Dropshipping Works</div>
        <div><img src="../../static/imgs/land3.png" alt="" /></div>
      </div>
    </div>
    <div class="home_what">
      <div class="home_what_url"></div>
      <div class="home_what_box">
        <div class="home_title">What is ANTDIY?</div>
        <div class="home_what_line">
          <div class="home_what_line_text">
            <div class="title_icon home_what_line_text_symbol"></div>
            <div class="home_what_line_text_title">
              ANTDIY is Dropshipping app of AliExpress Official Partner
            </div>
            <div class="home_what_line_text_content">
              It allows you to find all kinds of products to sell online, add
              them to your Shopify store, and start selling now. Never worry
              about packaging or shipping, and focus on developing your
              business.
            </div>
          </div>
          <div class="home_what_line_img">
            <img src="../../static/imgs/land4.jpg" />
          </div>
        </div>
        <div class="home_what_line home_what_line2">
          <div class="home_what_line_img">
            <img src="../../static/imgs/land5.jpg" />
          </div>
          <div class="home_what_line_text">
            <div class="title_icon home_what_line_text_symbol"></div>
            <div class="home_what_line_text_title">
              Directly connected to the AliExpress platform
            </div>
            <div class="home_what_line_text_content">
              We provide you with access to billions of products.Our supply
              chain innovations enable us to offer you good prices by connecting
              you with suppliers from AliExpress.
            </div>
          </div>
        </div>
        <div class="home_what_line">
          <div class="home_what_line_text">
            <div class="title_icon home_what_line_text_symbol"></div>
            <div class="home_what_line_text_title">
              ANTDIY: AliExpress Dropshipping Ecommerce Plugins for Online
              Stores!
            </div>
            <div class="home_what_line_text_content">
              ANTDIY provides dropshippers with a one-stop solution to purchase
              cross-border products as simply and reliably as they do from local
              quality suppliers.
            </div>
          </div>
          <div class="home_what_line_img">
            <img src="../../static/imgs/land6.jpg" />
          </div>
        </div>
        <div class="home_what_bottom">
          <div class="home_what_bottom_title1">ANTDIY supported platforms</div>
          <div class="home_what_bottom_platform">
            <div class="home_what_bottom_img1" ><img src="../assets/land30.svg" class="home_what_bottom_img1_img1" alt="Shopify"></div>
            <div class="home_what_bottom_img1" ><img src="../assets/land31.svg" class="home_what_bottom_img1_img2" alt="BigCommerce"></div>
            <div class="home_what_bottom_img2" >
              <img src="../assets/land33.svg" class="home_what_bottom_img2_img2"  alt="WooCommerce">
            </div>
            <div class="home_what_bottom_img2" >
              <img src="../assets/land32.svg"  class="home_what_bottom_img2_img1" alt="Wix">
            </div>
          </div>
          <div class="home_what_bottom_title2">More platforms coming soon</div>
        </div>
      </div>
    </div>
    <div class="landingpage_sign">
      <div class="landingpage_sign_box">
        <div class="landingpage_sign_title">
          <div class="landingpage_sign_title1">Are you ready to start</div>
          <div class="landingpage_sign_title1">
            your dropshipping business today?
          </div>
        </div>
        <div class="landingpage_sign_title2">
          Join ANTDIY for free and open the door to wealth!
        </div>
        <div  class="landingpage_sign_title3" @click="signscroll">
          <span class="landingpage_sign_title5"
            ><a style="text-decoration: none"
              >Sign up for free</a
            ></span
          >
        </div>
        <div class="landingpage_sign_title4" @click="bounse">Get free expert consultation</div>
      </div>
    </div>
    <div class="landingpage_soulutions">
       <div class="landingpage_soulutions_url"></div>
      <div class="landingpage_soulutions_box">  
        <div class="landingpage_soulutions_title">
          <div class="landingpage_soulutions_title1">
            Our unique solutions are creating a wave of buzz with dropshippers
            just like you
          </div>
        </div>
        <div class="landingpage_soulutions_title2">
          Whether you’re total newbie or a seasoned expert with a multi-million
          dollar turnover—we have the exact solution you’re looking for!
        </div>
        <div class="landingpage_soulutions_center">
          <div class="landingpage_soulutions_content">
            <img src="../assets/land11.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                Cash in on huge profit margins
              </div>
              <div class="landingpage_soulutions_content_right3">
                There are millions of AilExpress product at extremely low
                prices, so you’ll benefit from unprecedented profit margins
                (read:thousands of percent).
              </div>
            </div>
          </div>

          <div class="landingpage_soulutions_content">
            <img src="../assets/land6.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                Order a custom store
              </div>
              <div class="landingpage_soulutions_content_right3">
                Don’t have the time or patience to build your own website? Then
                let us do all the heavy lifting for you! We’ll build you a
                beautiful store you’ll be thrilled to put your name on!
              </div>
            </div>
          </div>

          <div class="landingpage_soulutions_content2">
            <img src="../assets/land4.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                Our services & lifelong support
              </div>
              <div class="landingpage_soulutions_content_right3">
                We have wide range of high-quality services to help you succeed
                through every phase of growth.We offer free personal support for
                every solution you order—so you’ll always have us as your secret
                weapon!
              </div>
            </div>
          </div>

          <div class="landingpage_soulutions_content2">
            <img src="../assets/land5.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                Expand your business anytime
              </div>
              <div class="landingpage_soulutions_content_right3">
                We don’t limit you on the number of products you can have or the
                monthy sales you can get.Even if you have tens of thousands of
                products and millions of orders, you pay NO extra fees!It’s our
                guarantee.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landingpage_service">
      <div class="landingpage_service_box">
        <div class="landingpage_service_box_title">
          When you join ANTDIY, we also provide the following high value-added
          services
        </div>
        <div class="landingpage_soulutions_center">
          <div class="landingpage_soulutions_content">
            <img src="../assets/land7.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                Shipping service and order tracking
              </div>
              <div class="landingpage_soulutions_content_right4">
                <li class="landingpage_soulutions_content_right4_li">
                  <span>Shipping from local inventory in</span> 3
                  <span>days</span>
                </li>
                <li>
                  <span>Shipping from China in </span>7
                  <span>working days</span>
                </li>
              </div>
            </div>
          </div>

          <div class="landingpage_soulutions_content">
            <img src="../assets/land8.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                Product Sourcing
              </div>
              <div class="landingpage_soulutions_content_right4">
                Get you access to tens of thousands of SKU selections from
                different sellers
              </div>
            </div>
          </div>

          <div class="landingpage_soulutions_content2">
            <img src="../assets/land9.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                24 / 7 Expert Support
              </div>
              <div class="landingpage_soulutions_content_right4">
                When you encounter any problems, just contact us through Fresh
                chat, we will help you solve the problem as soon as possible
              </div>
            </div>
          </div>

          <div class="landingpage_soulutions_content2">
            <img src="../assets/land10.svg" alt="" />
            <div class="landingpage_soulutions_content_right">
              <div class="landingpage_soulutions_content_right2">
                100 Local Warehouses
              </div>
              <div class="landingpage_soulutions_content_right4">
                In the USA, UK, and EUROPE
              </div>
            </div>
          </div>
        </div>
        <div class="landingpage_soulutions_bottom">
          More services will be updated later, join ANTDIY free now!
        </div>
      </div>
    </div>
    <div class="landingpage_heard">
      <div class="landingpage_heard_url"></div>
      <div class="landingpage_heard_box">
        <div class="landingpage_heard_title">YOU HEARD ME RIGHT!!!</div>
        <div class="landingpage_heard_center">
          <div class="landingpage_heard_content">
            <img src="../../static/imgs/land15.png" alt="" />
            <div class="landingpage_heard_content_div">
              <span >https://www.kol-dropshipping.com</span
              >
            </div>
          </div>
          <div class="landingpage_heard_content2">
            <div class="title_icon landingpage_heard_content2_icon"></div>
            <div class="landingpage_heard_content2_line">
              With <span>100,000 Items</span>, it only took
              <span>3 days</span> to store with ANTDIY!!!
            </div>
            <div class="landingpage_heard_content2_line2">
              Don’t you want to also own a store?
            </div>
            <div class="landingpage_heard_content2_line3">
              Join ANTDIY for free and open the door to wealth!
            </div>
            <div  class="landingpage_heard_content2_line4" @click="signscroll">
              <span
                ><a  style="text-decoration: none"
                  >Sign up for free</a
                ></span
              >
            </div>
            <div class="landingpage_heard_content2_line5" @click="bounse">
              Get free expert consultation
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landingpage_questions">
      <div class="landingpage_questions_box">
        <div class="landingpage_questions_title">
          FREQUENTLY ASKED QUESTIONS
        </div>
        <div class="landingpage_questions_content">
          <img src="../assets/land12.svg" alt="" />
          <div class="landingpage_questions_content_right">
            <div class="landingpage_questions_content_right_line">
              What e-Commerce platforms does ANTDIY support?
            </div>
            <div class="landingpage_questions_content_right_line2">
              Currently we integrate with Shopify, WooCommerce, BigCommerce.
            </div>
          </div>
        </div>
        <div class="landingpage_questions_content">
          <img src="../assets/land13.svg" alt="" />
          <div class="landingpage_questions_content_right">
            <div class="landingpage_questions_content_right_line">
              Will ANTDIY work for my country?
            </div>
            <div class="landingpage_questions_content_right_line2">
              Yes! Since suppliers ship the items directly to your customers,
              dropshipping is borderless and can be done from anywhere in the
              world.
            </div>
          </div>
        </div>
        <div class="landingpage_questions_content">
          <img src="../assets/land14.svg" alt="" />
          <div class="landingpage_questions_content_right">
            <div class="landingpage_questions_content_right_line">
              What supply platforms do we support?
            </div>
            <div class="landingpage_questions_content_right_line2">
              Currently we are cooperating with AliExpress. In the future, we
              will also cooperate with Alibaba, 1688, Taobao...
            </div>
          </div>
        </div>
        <div class="landingpage_questions_content">
          <img src="../assets/land15.svg" alt="" />
          <div class="landingpage_questions_content_right">
            <div class="landingpage_questions_content_right_line">
              Does ANTDIY charge？
            </div>
            <div class="landingpage_questions_content_right_line2">
              No, our products and services are completely free, there are no
              hidden charges or taxes.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_say">
      <div class="home_say_box">
        <div class="home_say_title">What are users saying about us?</div>
        <div class="home_say_content">
          <div
            class="home_say_left home_say_click"
            @click="clickLeft"
            @mouseover="slideOver2"
            @mouseout="slideOut2"
          >
            <img
              src="../../static/imgs/land21.png"
              alt=""
              v-if="left_icon == false"
            />
            <img src="../../static/imgs/land23.png" alt="" v-else />
          </div>
          <div class="home_say_content_line">
            <div
              id="slide"
              class="home_say_content_item"
              v-for="(item, index) in sayList"
              :key="index"
              :style="{
                transform: `translateX(${-sayIndex * 610 + 10 + 'px'})`,
              }"
              @mouseenter="slideOver3"
              @mouseleave="slideOut3"
            >
              <div class="home_say_content_top">
                <img :src="item.icon" alt="" />
                <span class="home_say_content_top_name">{{ item.name }}</span>
                <em></em>
                <span class="home_say_content_top_country">{{
                  item.country
                }}</span>
              </div>
              <div class="home_say_content_text">{{ item.content }}</div>
            </div>
          </div>
          <div
            class="home_say_right home_say_click"
            @click="clickRight"
            @mouseover="slideOver"
            @mouseout="slideOut"
          >
            <img
              src="../../static/imgs/land22.png"
              alt=""
              v-if="right_icon == false"
            />
            <img src="../../static/imgs/land24.png" alt="" v-else />
          </div>
        </div>
      </div>
    </div>
    <a name="aaa"></a>
    <div class="landingpage_bottom">
      <div class="landingpage_bottom_box">
        <div class="landingpage_bottom_center">
          <div class="landingpage_bottom_title">
            Why are you still hesitating?The time to make money is passing by
            every minute!
          </div>
          <div class="landingpage_bottom_title2">
            Join ANTDIY for free and open the door to wealth!
          </div>
          <form action="" ref="formcheck" class="landingpage_form">
            <div class="landingpage_register_div">
              <input
                @input="checkEmail"
                v-model="mailtext"
                type="text"
                placeholder="Email"
                class="landingpage_register_content1"
                :disabled="codeshow2"
                :style="codeshow2 ? 'cursor:no-drop' : ''"
              />
              <div id="landingpage_register_email">
                {{ emailvalue }}
              </div>
            </div>
            <div class="landingpage_register_code">
              <div class="landingpage_register_div2">
                <input
                  @input="checkcode"
                  v-model="mailtext2"
                  type="text"
                  placeholder="Verification Code"
                  class="landingpage_register_content2"
                />
                <div id="landingpage_register_email2">
                  {{ emailvalue2 }}
                </div>
                 <div id="landingpage_register_email2" v-if="codebox==true">
                  {{ codeerror }}
                </div>
              </div>
              <button
                class="landingpage_register_content2_button"
                @click="getcode"
                v-if="codeshow"
                :disabled="!visible"
                :style="!visible ? 'cursor:no-drop' : ''"
              >
                Get Code
              </button>
              <div
                class="landingpage_register_content2_button"
                id="daojishi"
                v-if="codeshow2"
                @mouseenter="mouseentera"
                @mouseleave="mouseleavea"
              >
                {{ this.yztime + "s" }}
                <div
                id="landingpage_register_banner"  
                 v-if="codeshow3"       
              >
                Didn't get it? Check your spam folder.
              </div>
              <div class="landingpage_register_banner2"  v-if="codeshow3"></div>
              </div>
            </div>
            <div class="landingpage_register_div3">
              <input
                type="text"
                @input="checkpassword"
                v-model="mailtext3"
                placeholder="Password"
                class="landingpage_register_content3"
              />
              <div id="landingpage_register_email3">
                {{ emailvalue3 }}
              </div>
            </div>
            <div class="landingpage_register_content4" @click="handleSubmit">
              Sign up for free
            </div>
            <div class="landingpage_register_content5">
              By clicking Sign Up, you agree to our
              <a
                :href="'https://www.antdiy.vip/detail?p=3&source=' + source"
                class="landingpage_a"
                target="_blank"
                >Terms of Service</a
              >
              and
              <a
                :href="'https://www.antdiy.vip/detail?p=3&source=' + source"
                class="landingpage_a"
                target="_blank"
                >Privacy Policy.</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="landingpage_banner">© 2023 ANTLINKS All Rights Reserved.</div>
  </div>
</template>

<script>
export default {
  name: "Landingpage",
  components: {},
  data() {
    return {
      sayList: [
        {
          icon: "/static/imgs/portrait1.png",
          name: "Ga**ett",
          country: "US",
          content:
            "“I am the owner of a dedicated e-platform. The one-stop supply chain solution from Antdiy enables hassle-free integration with various modules including Product, Order, Parcel and Logistics through the Open API, which frees us from the burden of dealing with multiple service providers. Plus, it helps us greatly diversify our product offerings, and now Chinese products are seeing a 55% increase in sales.”",
        },
        {
          icon: "/static/imgs/portrait2.png",
          name: "Sn**ky",
          country: "South Africa",
          content:
            "“Love Antdiy. They make it so easy to set it up a store with products. Especially bulk order function, you can save a lot of time and be accurate at the same time when you have more than 100 orders. this is where Antdiy really shines. thank you！”",
        },
        {
          icon: "/static/imgs/portrait3.png",
          name: "Hom***ario",
          country: "US",
          content: `“I used the ANTDIY app to increase the product selection in my online store. It did not disappoint！ ANTDIY currently assisted me to enhance the sales. I used the app it's great i recomend 100% more than 1000 sells in one hour the best, for beginers and it's free.”`,
        },
        {
          icon: "/static/imgs/portrait4.png",
          name: "Da**in",
          country: "Canada",
          content: `“It's a very useful application for dropshipping automation, it's easy and also simple to use user interface with one-click import products. I use it as a begginer, find specific items within a certain niche. The info gathered and sorted saves me much time and effort！ This has actually made my life so much less complicated！！！！”`,
        },
        {
          icon: "/static/imgs/portrait5.png",
          name: "De**nt",
          country: "US",
          content: `“Thank ANTDIY！ Looks and works great！ Huge upgrade over our products and orders, Fulfil bulk orders with one click！ A "must have' one, especially for drop shipping！！ I can't also envision doing this without it now.”`,
        },
        {
          icon: "/static/imgs/portrait6.png",
          name: "Ki**n",
          country: "US",
          content:
            "“Very well worth and easy to use, it is fast and efficient. They have good customer service, terrific client assistance answer with in less than a minute.”",
        },
        {
          icon: "/static/imgs/portrait7.png",
          name: "Sa**y",
          country: "Canada",
          content: `“I get notices regarding AliExpress products that are out of supply as well as my shop is updated instantly so that my clients  aren't buying something I can not fufill. Integrated tracking for orders, and also a support team that is really responsive as well as very useful step by step direction when required！”`,
        },
        {
          icon: "/static/imgs/portrait8.png",
          name: "Sh**im",
          country: "Canada",
          content:
            '“ANTDIY is simply the most effective Dropshipping App on the marketplace. Highly recommended！ “fully computerized"... “time conserving"...“free e-commerce education and learning."',
        },
        {
          icon: "/static/imgs/portrait9.png",
          name: "Mo**ca",
          country: "US",
          content: `“ANTDIY saves me a lot time in regards to adding items, editing photos as well as mapping the versions. I would love to have the alternative of uploading photos or editing and enhancing images through ANTDIY. I'm really amazed！ It is a terrific application ever before ^ ^ It's truly practical for me ！！ Thanks ANTDIY^ ^ You are the best."`,
        },
      ],
      sayIndex: 0,
      // trNum: 610
      handleScrollFlag: true,
      slideshow: undefined,
      screenWidth: window.innerWidth,
      isMobileHome: false,
      RollPointActive: 1,
      time: undefined,
      changeSayTimer: undefined,
      confirmDirty: false,
      autoCompleteResult: [],
      loading: false,
      yztime: 59,
      visible: false,
      visible2: false,
      visible3: false,
      visible4: false,
      isAndroid: false,
      timer: undefined,
      source: localStorage.getItem('ant_source') || '',
      showAlert: false,
      codeshow: true,
      codeshow2: false,
      codeshow3: false,
      mailtext: "",
      mailtext2: "",
      mailtext3: "",
      emailvalue: "",
      emailvalue2: "",
      emailvalue3: "",
      left_icon: false,
      right_icon: false,
      codeerror:"",
      codebox:false,
    };
  },
  methods: {
    enlargeSayList() {
      if (this.screenWidth > 767) {
        this.sayList.unshift(this.sayList[this.sayList.length - 1]);
        // this.sayList.push =
        this.sayList[this.sayList.length] = this.sayList[1];
        this.sayIndex = 1;
      }
    },
    bounse(){
      if (window.Tawk_API) {
        window.Tawk_API.maximize();
      }
      return
      if (window.fcWidget) {
         window.fcWidget.open()
    }
    },
    clickLeft() {
      let date1 = new Date().getTime();
      if (!this.time || this.time < date1 - 500) {
        this.time = date1;
        if (this.sayIndex == 0) {
          for (let i = 0; i < this.sayList.length; i++) {
            document.querySelector(".home_say_content_item").className =
              "home_say_content_item_no_transition";
          }
          this.sayIndex = this.sayList.length - 2;
          this.changeSayTimer = setTimeout(this.changeSeamless, 500);
        } else {
          this.sayIndex--;
        }
      }
    },
    clickRight() {
      let date1 = new Date().getTime();
      if (!this.time || this.time < date1 - 500) {
        this.time = date1;
        if (this.sayIndex == this.sayList.length - 2) {
          for (let i = 0; i < this.sayList.length; i++) {
            document.querySelector(".home_say_content_item").className =
              "home_say_content_item_no_transition";
          }
          this.sayIndex = 0;
          this.changeSayTimer = setTimeout(this.changeSeamless, 500);
        } else {
          this.sayIndex++;
        }
      }
    },
    changeSeamless() {
      clearTimeout(this.changeSayTimer);
      if (this.sayIndex == 0) {
        for (let i = 0; i < this.sayList.length; i++) {
          document.querySelector(
            ".home_say_content_item_no_transition"
          ).className = "home_say_content_item";
        }
        this.sayIndex++;
      } else {
        for (let i = 0; i < this.sayList.length; i++) {
          document.querySelector(
            ".home_say_content_item_no_transition"
          ).className = "home_say_content_item";
        }
        this.sayIndex--;
      }
    },
    goLink(url) {
      window.open(url);
    },
    handleScrollHome() {
      if (
        this.handleScrollFlag &&
        this.screenWidth > 767 &&
        document.querySelector(".home_say_box")
      ) {
        var exp_height = document
          .querySelector(".home_say_box")
          .getBoundingClientRect().top;
        clearInterval(this.slideshow);
        if (exp_height < 450 && exp_height > -300) {
          this.handleScrollFlag = false;
          this.slideshow = setInterval(this.clickRight, 2000);
        }
      }
    },
    keyRollChange() {
      let keyLine = document.querySelector(".home_key_line");
      let id =
        (keyLine.scrollLeft / (keyLine.scrollWidth - keyLine.clientWidth)) * 9;
      if (id > 9) {
        id = 9;
      }
      this.RollPointActive = id == 0 ? 1 : Math.ceil(id);
    },
    slideOver() {
      this.right_icon = true;
      if (this.screenWidth > 767) {
        clearInterval(this.slideshow);
      }
    },
    slideOut() {
      this.right_icon = false;
      if (this.screenWidth > 767) {
        // this.clickRight()
        this.slideshow = setInterval(this.clickRight, 2000);
      }
    },
    slideOver2() {
      this.left_icon = true;
      if (this.screenWidth > 767) {
        clearInterval(this.slideshow);
      }
    },
    slideOut2() {
      this.left_icon = false;
      if (this.screenWidth > 767) {
        // this.clickRight()
        this.slideshow = setInterval(this.clickRight, 2000);
      }
    },
    slideOver3() {
      if (this.screenWidth > 767) {
        clearInterval(this.slideshow);
      }
    },
    slideOut3() {
      if (this.screenWidth > 767) {
        // this.clickRight()
        this.slideshow = setInterval(this.clickRight, 2000);
      }
    },
    tabScroll() {
      window.addEventListener("scroll", this.handleScrollHome);
    },
    keyRoll() {
      window.addEventListener("scroll", this.keyRollChange, true);
    },
    count() {
      let siv = setInterval(() => {
        this.yztime--;
        if (this.yztime <= -1) {
          clearInterval(siv); //倒计时( setInterval() 函数会每秒执行一次函数)，用 clearInterval() 来停止执行:
          this.codeshow3 = false;
          this.codeshow = true;
          this.codeshow2 = false;
          this.yztime = 59;
          this.showAlert = true;
        }
      }, 1000);
      this.timer = siv;
    },
    getcode(e) {
      //邮箱验证码
      let _this = this;
      clearInterval(this.timer);
      this.codeshow2 = true;
      this.codeshow3 = true;
      setTimeout(()=>{
        this.codeshow3 = false;
      },2000)
      this.codeshow = false;
      this.yztime = 59;
      this.showAlert = true;
      _this.count();

      e.preventDefault();
      this.$axios.post(`https://gateway.antdiy.vip/account-service/email/send`, {
          email: this.mailtext.trim(),
          type: 1,
          series_id: 1,
        })
        .then(function (response) {
          if (response.data.success) {         
          } else {
            // message.error(response.msg)
            // _this.setState({ loading: false });
            this.codeshow3 = true;
            this.codeshow2 = true;
            this.codeshow = false;
            clearInterval(_this.timer);
            this.yztime = response.wait;
            this.showAlert = true;
            _this.count();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mouseleavea() {
      this.codeshow3 = false;
    },
    mouseentera() {
      this.codeshow3 = true;
    },
    signscroll(){
       // 获取滚动条高度的固定写法,document.documentElement是获取根节点<html>,document.body是获取<body>
      //  因为页面有些有 DOCTYPE ,所以两个都写就可以了
      let start = document.documentElement.scrollTop || document.body.scrollTop;
      console.log(start)
      // .getBoundingClientRect()表示某个元素到浏览器视窗的位置,top就是该元素的top到浏览器视窗的位置
        let end = document.querySelector('.landingpage_bottom').getBoundingClientRect().top 
         console.log(end)
        // 将end位置分成220份,每次走几份,count越大每次走的越快,下面分成三种走法,加起来就是220份正好走完
        let step = (end)/220;
        let d = step
        let count = 0;
        let timer =  setInterval(() => {
          if (count > 30 && count <= 70) {
            d = 3*step
          } else if (count > 10 && count <= 90) {
            d = 2*step
          } else if (count > 0 && count < 100) {
            d = step
          }
          start += d
          window.scrollTo(0, start)
          count++;
          if (count >= 100) {
            clearInterval(timer)
          }
        }, 10);
    },
    handleSubmit() {
      //用户注册
      //  检查邮箱
      if (this.visible == false && this.visible4 == false) {
        this.emailvalue = "Your email must be valid.";
      } else if (this.visible == false && this.visible4 == true) {
        this.emailvalue = "This email has been registered.";
      }
      // 检查code
      if (this.mailtext2.trim() == "" || undefined) {
        this.emailvalue2 = "Verification code must be valid.";
      } else if (this.mailtext2.trim().length < 4) {
        this.emailvalue2 = "Invalid code, please check.";
      }
      // 检查password
      if (this.visible3 == false) {
        this.emailvalue3 =
          "6 characters or numbers minimum and 20 characters or numbers maximum.";
      }

      if (
        this.visible3 == true &&
        this.visible2 == true &&
        this.visible == true
      ) {
        this.$axios
          .post(`https://gateway.antdiy.vip/account-service/user/register`, {
            mailbox: this.mailtext.trim(),
            code: this.mailtext2.trim(),
            password: this.mailtext3.trim(),
            source: this.source,
            series_id: 1,
          })
          .then((response) => {
            if (response.data.success) {
              window.location.href = "https://platform.antdiy.vip/#/login";
            } else {
              this.codebox=true
              this.codeerror=response.data.msg
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    checkpassword() {
      /* eslint-disable */
      this.visible3 = false;
      var reg =
        /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,20}$/;
      let data = this.mailtext3.trim();
      if (data && !reg.test(data)) {
        this.emailvalue3 =
          "6 characters or numbers minimum and 20 characters or numbers maximum.";
      } else {
        if(data==""){
          this.visible3 = false;
        }else{
            this.visible3 = true;
        }
        this.emailvalue3 = "";
      }
      /* eslint-disable */
    },
    checkEmail() {
      this.visible = false;
      this.visible4 = false;
      let data = this.mailtext.trim();
      /* eslint-disable */
      let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      /* eslint-disable */
      if (data === undefined) {
        this.emailvalue = "Your email must be valid.";
      }
      if (data === "") {
        this.emailvalue = "";
      }
      if (data && !reg.test(data)) {
        this.emailvalue = "Your email must be valid.";
      }
      if (data && reg.test(data)) {
        this.$axios
          .post(`https://gateway.antdiy.vip/account-service/email/exist`, {
            email: data,
            type: 1,
            series_id: 1,
          })
          .then((res) => {
            if (res.data.success == false) {
              this.visible4 = true;
              this.emailvalue = "This email has been registered.";
            } else {
              this.visible = true;
              this.emailvalue = "";
            }
          });
      }
    },
    checkcode() {
      // trim()去除空格
      this.codebox=false
      this.visible2 = false;
      let code = this.mailtext2.trim();
      if (code === undefined || code === "") {
        this.emailvalue2 = "Verification code must be valid.";  
      } else if (code.length < 4) {
        this.emailvalue2 = "Invalid code, please check.";
      } else {
        this.visible2 = true;
        this.emailvalue2 = "";
      }
    },
    goPrivacy(e) {
      if (this.isAndroid) {
        this.goLink("privacy");
        return;
      }
      window.open(
        `https://www.antdiy.vip/detail?p=3&source=${
          this.source || "antdiy.vip"
        }`,
        "_blank"
      );
    },
  },
  created() {
    this.enlargeSayList();
    if (document.body.offsetWidth > 767) {
      this.isMobileHome = false;
    } else {
      // this.isMobileHome = true
    }
  },
  mounted() {
    // 设置最小宽度出现滚动条
    if (this.isMobileHome) {
      // this.keyRoll();
    } else {
      this.tabScroll();
    }
  },
  deactivated() {
    if (this.isMobileHome) {
      // window.removeEventListener('scroll', this.keyRollChange, true)
    } else {
      window.removeEventListener("scroll", this.handleScrollHome);
      if (this.slideshow) {
        window.clearInterval(this.slideshow);
      }
    }
  },
};
</script>

<style scoped>
.landingpage {
  overflow: hidden;
}
.landingpage_a {
  color: #8d919b;
  font-weight: bold;
}
.landingpage_register {
  background-color: #ffffff;
  height: 722px;
}
.landingpage_register_box {
  display: flex;
  justify-content: center;
}
.landingpage_register_img1 {
  margin-top: 80px;
  margin-left: 12px;
}
.landingpage_register_img1 img{
  width: 253px;
  height: 78px;
}
.landingpage_register_img2 {
  margin-top: 28px;
}
.landingpage_register_img2 img{
  width: 95%;
  height: 95%;
}
.landingpage_register_content4:hover{
   background: #E44C1D;
}
.landingpage_register_center {
  margin-top: 80px;
  margin-left: 19px;
}
#landingpage_register_banner {
  font-size: 14px;
  transform: translate(-50%,0);
  position: absolute;
  top: -44px;
  left: 50%;
  height: 34px;
  width: 248px;
  line-height: 34px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  word-wrap: break-word;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
    0 9px 28px 8px rgb(0 0 0 / 5%);
}
.landingpage_register_banner2 {
   transform: translate(-50%,0);
  width: 0;
  height: 0;
  border: 5px solid #000;
  border-color: rgba(0, 0, 0, 0.75) transparent transparent transparent;
  position: absolute;
  top: -10px;
  left: 50%;
}
.landingpage_register_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 38px;
  text-align: center;
}
.landingpage_register_div {
  width: 621px;
  height: 68px;
  margin: 40px 0 32px 0;
}
.landingpage_register_div2 {
  width: 432px;
  height: 68px;
}
.landingpage_register_div3 {
  width: 621px;
  height: 68px;
  margin: 31px 0 57px 0;
}
.landingpage_register_content1 {
  width: 621px;
  height: 68px;
  padding-left: 37px;
  background: #f5f7fc;
  border-radius: 12px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  font-size: 20px;
  font-family: Helvetica;
  color: rgba(0, 0, 0, 0.28);
  line-height: 24px;
}
.landingpage_register_content1:hover {
  border: 1px solid red;
}
.landingpage_register_code {
  display: flex;
  align-items: center;
}
.landingpage_register_content2 {
  width: 432px;
  height: 68px;
  background: #f5f7fc;
  padding-left: 37px;
  border-radius: 12px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  font-size: 20px;
  color: rgba(0, 0, 0, 0.28);
  line-height: 24px;
}
.landingpage_register_content2:hover {
  border: 1px solid red;
}
.landingpage_register_content2_button {
  width: 169px;
  height: 68px;
  border-radius: 12px;
  border: 1px solid #cbccce;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.42);
  line-height: 68px;
  text-align: center;
  margin-left: 20px;
  background-color: white;
  position: relative;
}
.landingpage_register_content2_button:hover {
  border: 1px solid red;
  color: red;
}
.landingpage_register_content3 {
  width: 621px;
  height: 68px;
  background: #f5f7fc;
  border-radius: 12px;
  padding-left: 37px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  font-size: 20px;
  font-family: Helvetica;
  color: rgba(0, 0, 0, 0.28);
  line-height: 24px;
}
.landingpage_register_content3:hover {
  border: 1px solid red;
}
.landingpage_register_content4 {
  width: 621px;
  height: 68px;
  background: #fb5421;
  border-radius: 4px;
  font-size: 24px;
  color: #ffffff;
  line-height: 68px;
  text-align: center;
  margin-bottom: 25px;
  cursor: pointer;
}
.landingpage_register_content4:hover{
  background: #E44C1D;
}
.landingpage_register_content5 {
  font-size: 18px;
  color: #8d919b;
  line-height: 18px;
  text-align: center;
}
.landingpage_register_content5 span {
  font-weight: bold;
}
.landingpage_drop {
  height: 401px;
  background-color: #ffe5dd;
}
.landingpage_drop_title {
  text-align: center;
  padding-top: 80px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
}
.landingpage_drop_content {
  display: flex;
  justify-content: center;
  margin-top: 51px;
}
.landingpage_drop_div {
  width: 276px;
  height: 140px;
  text-align: center;
}
.landingpage_drop_div2 {
  width: 276px;
  height: 140px;
  text-align: center;
}

.landingpage_drop_font {
  font-size: 36px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fb5421;
  line-height: 28px;
  margin: 31px 0 26px 0;
}
.landingpage_drop_font2 {
  font-size: 26px;
  font-family: Helvetica;
  color: #222536;
  line-height: 24px;
}
.landingpage_img {
  background-color: #ffffff;
  height: 849px;
  position: relative;
}
.landingpage_img_box {
  width: 1200px;
  margin: auto;
  position: relative;
  z-index: 10;
}
.landingpage_img_box img{
  width: 1202px;
  height: 540px;
}
.landingpage_img_url{
  background: url(../../static/imgs/land25.png);
  width: 557px;
  height: 352px;
  position: absolute;
  z-index: 1;
  opacity: 0.79;
}
.landingpage_img_url2{
  background: url(../../static/imgs/land26.png);
  width: 557px;
  height: 352px;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  opacity: 0.79;
}
.landingpage_img_title {
  padding: 79px 0 90px 0;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.home_title {
  padding: 81px 0 40px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.home_what {
  background: #f6f7fa;
   position: relative;
}
.home_what_url{
  background: url(../../static/imgs/land28.png);
  width: 802px;
  height: 583px;
  position: absolute;
  top: 342px;
  right: 0;
  z-index: 1;
  opacity: 0.79;
}
.home_what_box {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 10;
}
.home_what_line {
  display: flex;
  justify-content: space-between;
  height: 355px;
  padding-bottom: 80px;
  overflow: hidden;
}
.home_what_line_text {
  width: 580px;
}
.home_what_line_text_symbol {
  margin: 66px 0 21px;
}
.home_what_line_text_title {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 28px;
  margin-bottom: 20px;
}
.home_what_line_text_content {
  font-size: 20px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
}
.home_what_line_img {
  width: 492px;
  height: 298px;
  background: rgba(252, 83, 34, 0.12);
  border-radius: 20px;
}
.home_what_line_img img {
  width: 450px;
  height: 260px;
  margin: 21px;
}
.home_what_line_text + .home_what_line_img,
.home_what_line_img + .home_what_line_text {
  margin-left: 43px;
}
.home_what_bottom{
  padding: 40px 0 100px 0;
}
.home_what_bottom_title1{
  font-size: 32px;
font-family: Helvetica-Bold, Helvetica;
font-weight: bold;
color: #222536;
line-height: 40px;
text-align: center;
}
.home_what_bottom_title2{
font-size: 24px;
font-family: Helvetica;
color: #8D919B;
line-height: 29px;
text-align: center;
}
.home_what_bottom_platform{
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 48px 0 36px 0;
}
.home_what_bottom_img1{
width: 283px;
height: 136px;
background: #FFFFFF;
border-radius: 8px;
text-align: center;
    line-height: 136px;
}
.home_what_bottom_img1_img1{
width: 159px;
height: 56px;
}
.home_what_bottom_img1_img2{
width: 200px;
height: 45px;
}
.home_what_bottom_img2{
width: 283px;
height: 136px;
background: #FFFFFF;
border-radius: 8px;
text-align: center;
line-height: 136px;
position: relative;
}
.home_what_bottom_img2_img1{
width: 150px;
height: 51px;
}
.home_what_bottom_img2_img2{
width: 200px;
height: 41px;
}
.home_what_bottom_img2_div{
 width: 107px;
height: 26px;
font-size: 14px;
font-family: Helvetica;
color: #222536;
line-height: 26px;
text-align: center;
background: #D8D8D8;
border-radius: 8px 0px 8px 0px;
opacity: 0.4;
position: absolute;
top: 0;
left: 0;
}
.landingpage_sign {
  height: 519px;
  background-color: #ffffff;
}
.landingpage_sign_box {
  width: 571px;
  margin: auto;
  text-align: center;
}
.landingpage_sign_title {
  padding-top: 80px;
}
.landingpage_sign_title1 {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 38px;
}
.landingpage_sign_title2 {
  font-size: 24px;
  color: #333333;
  line-height: 29px;
  margin: 36px 0 60px 0;
}
.landingpage_sign_title3 {
  width: 556px;
  height: 80px;
  background: #fb5421;
  box-shadow: 0px 6px 6px 0px rgba(251, 84, 33, 0.2);
  border-radius: 4px;
  font-size: 24px;
  color: #ffffff;
  line-height: 80px;
  margin: auto;
}
.landingpage_sign_title3:hover{
   background: #E44C1D;
}
.landingpage_sign_title5 a {
  color: #ffffff !important;
}
.landingpage_sign_title4 {
  font-size: 24px;
  color: #8d919b;
  margin-top: 29px;
  cursor: pointer;
}
.landingpage_soulutions {
  height: 807px;
  background: #f6f7fa;
  position: relative;
}
.landingpage_soulutions_url{
  background: url(../../static/imgs/land27.png);
  width: 795px;
  height: 588px;
  position: absolute;
  top: 110px;
  z-index: 1;
  opacity: 0.79;
}
.landingpage_soulutions_box {
  width: 1200px;
  margin: auto;
  position: relative;
  z-index: 10;
}
.landingpage_soulutions_title {
  padding-top: 80px;
  margin-bottom: 30px;
  text-align: center;
}
.landingpage_soulutions_title1 {
  width: 742px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 38px;
  margin: auto;
}
.landingpage_soulutions_title2 {
  width: 844px;
  font-size: 24px;
  color: #333333;
  line-height: 29px;
  margin: auto;
  text-align: center;
}
.landingpage_soulutions_center {
  display: flex;
  flex-wrap: wrap;
  margin-top: 100px;
  justify-content: space-between;
}
.landingpage_soulutions_content {
  display: flex;
}
.landingpage_soulutions_content2 {
  display: flex;
  margin-top: 80px;
}
.landingpage_soulutions_content img {
  width: 96px;
  height: 96px;
}
.landingpage_soulutions_content2 img {
  width: 96px;
  height: 96px;
}
.landingpage_soulutions_content_right2 {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 29px;
}
.landingpage_soulutions_content_right{
  margin-top: 10px;
  margin-left: 7px;
}
.landingpage_soulutions_content_right3 {
  font-size: 18px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 22px;
  margin-top: 20px;
  width: 485px;
  height: 88px;
}
.landingpage_soulutions_content_right4 {
  font-size: 18px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 22px;
  margin-top: 20px;
  width: 470px;
  height: 88px;
}
.landingpage_soulutions_content_right4 li {
  color: #fc5322;
  font-weight: bold;
}
.landingpage_soulutions_content_right4 span {
  color: #8d919b;
  font-weight: normal;
}
.landingpage_soulutions_content_right4_li {
  margin-bottom: 17px;
}
.landingpage_service {
  height: 812px;
}
.landingpage_service_box {
  width: 1200px;
  margin: auto;
  padding-top: 80px;
}
.landingpage_service_box_title {
  width: 680px;
  height: 76px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 38px;
  text-align: center;
  margin: auto;
}
.landingpage_soulutions_bottom {
  text-align: center;
  font-size: 20px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
  margin-top: 70px;
}
.landingpage_heard {
  height: 711px;
  background: #f6f7fa;
  padding-top: 80px;
   position: relative;
}
.landingpage_heard_box {
  width: 1200px;
  margin: auto;
  position: relative;
  z-index: 10;
}
.landingpage_heard_url{
   background: url(../../static/imgs/land28.png);
  width: 802px;
  height: 583px;
  position: absolute;
  top: 58px;
  right: 0;
  z-index: 1;
  opacity: 0.79;
}
.landingpage_heard_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 38px;
  text-align: center;
}
.landingpage_heard_center {
  margin-top: 55px;
  display: flex;
}
.landingpage_heard_content {
  width: 658px;
}
.landingpage_heard_content img{
  width: 660px;
  height: 396px;
}
.landingpage_heard_content_div {
  text-align: center;
  font-size: 20px;
}
.landingpage_heard_content_div img {
  margin-right: 8px;
}
.landingpage_heard_content_div span {
  color: #8d919b;
  line-height: 24px;
}
.landingpage_heard_content2 {
  margin-left: 22px;
}
.landingpage_heard_content2_icon {
  margin: 30px 0 20px 0;
}
.landingpage_heard_content2_line {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 28px;
}
.landingpage_heard_content2_line span {
  color: #fc5322;
}
.landingpage_heard_content2_line2 {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
  margin: 32px 0 60px 0;
}
.landingpage_heard_content2_line3 {
  font-size: 20px;
  color: #333333;
  line-height: 24px;
}
.landingpage_heard_content2_line4 {
  width: 315px;
  height: 48px;
  background: #fc5322;
  border-radius: 4px;
  line-height: 48px;
  margin: 28px 0 20px 0;
  text-align: center;
  font-size: 16px;
  line-height: 48px;
}
.landingpage_heard_content2_line4:hover{
  background: #E44C1D;
}
.landingpage_heard_content2_line4 a {
  color: #ffffff !important;
}
.landingpage_heard_content2_line5 {
  font-size: 20px;
  color: #8d919b;
  line-height: 24px;
  cursor: pointer;
}
.landingpage_questions {
  height: 711px;
  padding-top: 80px;
}
.landingpage_questions_box {
  width: 1200px;
  margin: auto;
}
.landingpage_questions_title {
  font-size: 32px;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
  margin-bottom: 50px;
}
.landingpage_questions_content {
  display: flex;
}
.landingpage_questions_content img {
  width: 28px;
  height: 28px;
}
.landingpage_questions_content_right {
  margin-left: 15px;
  margin-bottom: 40px;
}
.landingpage_questions_content_right_line {
  font-size: 24px;
  font-weight: bold;
  color: #fc5322;
  line-height: 29px;
  margin-bottom: 15px;
}

.landingpage_questions_content_right_line2 {
  font-size: 22px;
  color: #222536;
  line-height: 28px;
}
.home_say {
  padding: 80px 0 60px;
  background: #f6f7fa;
  height: 575px;
}
.home_say_box {
  width: 1220px;
  margin: 0 auto;
}
.home_say_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin-bottom: 21px;
  text-align: center;
}
.home_say_content {
  position: relative;
}
.home_say_content_line {
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  padding: 18px 0 18px 0;
}
.home_say_left,
.home_say_right {
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  cursor: not-allowed;
}
.home_say_left {
  left: -58px;
}
.home_say_right {
  right: -58px;
}
.home_say_click:hover {
  background: #c9cdd7;
  cursor: pointer;
}
.home_say_content_item {
  flex: none;
  width: 590px;
  background: #fff;
  padding: 40px 40px 40px 32px;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.15);
  border-radius: 8px;
  transition: all 0.8s;
}
.home_say_content_item + .home_say_content_item {
  margin-left: 20px;
}
.home_say_content_item_no_transition {
  flex: none;
  width: 590px;
  background: #fff;
  padding: 40px 40px 40px 32px;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.15);
  border-radius: 8px;
}
.home_say_content_item_no_transition + .home_say_content_item_no_transition {
  margin-left: 20px;
}
.home_say_content_top {
  display: flex;
  align-items: center;
}
.home_say_content_top img {
  width: 48px;
  height: 48px;
}
.home_say_content_top em {
  width: 1px;
  height: 16px;
  background: #8d919b;
}
.home_say_content_top_name {
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 28px;
  margin: 0 15px 0 28px;
}
.home_say_content_top_country {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 28px;
  margin-left: 20px;
}
.home_say_content_text {
  margin: 21px 0 0 8px;
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
}
.landingpage_bottom {
  height: 859px;
  padding-top: 80px;
}
.landingpage_bottom_box {
  width: 738px;
  margin: auto;
}
.landingpage_bottom_title {
  width: 738px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 38px;
  text-align: center;
}
.landingpage_bottom_title2 {
  font-size: 24px;
  font-family: Helvetica;
  color: #333333;
  line-height: 29px;
  text-align: center;
  margin: 55px 0 40px 0;
}
.landingpage_form {
  width: 621px;
  margin: auto;
}

.landingpage_banner {
  height: 76px;
  background: #32404d;
  line-height: 76px;
  text-align: center;
  font-size: 16px;
  color: #8d919b;
}
#landingpage_register_email3,
#landingpage_register_email2,
#landingpage_register_email {
  font-size: 16px;
  margin-top: 5px;
  color: rgb(255, 77, 79);
}

@media (max-width: 767px) {
  .landingpage_register_banner2 {
    border: 0.05rem solid #000;
    position: absolute;
    top: initial;
    left:50%;
    bottom: .945rem;
    border-color: rgba(0, 0, 0, 0.75) transparent transparent transparent;
     transform:translate(-50%，0)
  }
  #landingpage_register_banner {
    height: auto;
    line-height: 0.34rem;
    border-radius: 0.02rem;
    position: absolute;
    left: 50%;
    bottom:1.04rem;
    top:initial;
    width: 2.48rem;
    padding: 0 .05rem;
    font-size: .14rem;
    transform:translate(-50%，0)
  }
  .landingpage_soulutions_url{
    display: none;
  }
  .landingpage_heard_url{
    display: none;
  }
  .home_what_url{
    display: none;
  }
  .landingpage_img_url{
display: none;
  }
  .landingpage_img_url2{
display: none;
  }
  .landingpage_register {
    height: auto;
    padding-top: 0.67rem;
    padding-bottom: 1rem;
  }
  .landingpage_register_img {
    text-align: center;
    margin-bottom: 0.34rem;
  }
  .landingpage_register_box {
    display: initial;
  }
  .landingpage_register_img1 {
    margin: 0;
  }
  .landingpage_register_img1 img {
    width: 2.8rem;
    height: 0.77rem;
  }
  .landingpage_register_title {
    font-size: 0.44rem;
    line-height: 0.6rem;
  }
  .landingpage_register_img2 {
    display: none;
  }
  .landingpage_register_center {
    width: 100%;
    padding: 0 0.48rem;
    margin: 0;
  }
  .landingpage_form {
    width: 100%;
  }
  .landingpage_register_div {
    width: 100%;
    height: 0.96rem;
    margin: 0.7rem 0 0.4rem 0;
  }
  .landingpage_register_content1 {
    width: 100%;
    height: 0.96rem;
    padding-left: 0.37rem;
    border-radius: 0.12rem;
    font-size: 0.28rem;
  }
  .landingpage_register_div2 {
    width: 4.3rem;
    height: 0.96rem;
    flex:1
  }
  .landingpage_register_content2 {
    width: 100%;
    height: 0.96rem;
    padding-left: 0.37rem;
    border-radius: 0.12rem;
    font-size: 0.28rem;
  }
  .landingpage_register_div3 {
    width: 100%;
    height: 0.96rem;
    margin: 0.4rem 0 0.77rem 0;
  }
  .landingpage_register_content3 {
    width: 100%;
    height: 0.96rem;
    padding-left: 0.37rem;
    border-radius: 0.12rem;
    font-size: 0.28rem;
  }
  .landingpage_register_content4 {
    width: 100%;
    height: 0.96rem;
    font-size: 0.28rem;
    line-height: 0.96rem;
    margin-bottom: 0.3rem;
    font-weight: bold;
  }
  .landingpage_register_content2_button {
    width: 2rem;
    height: 0.96rem;
    font-size: 0.2rem;
    line-height: 0.96rem;
    margin-left: 0.24rem;
    font-size: 0.28rem;
    color: rgba(0, 0, 0, 0.29);
    border-radius: .12rem;
    position: relative;
  }
  .landingpage_register_content5 {
    font-size: 0.18rem;
    line-height: 0.18rem;
  }
  #landingpage_register_email3,
  #landingpage_register_email2,
  #landingpage_register_email {
    font-size: 0.16rem;
    margin-top: 0.05rem;
  }

  .landingpage_drop {
    height: auto;
  }
  .landingpage_drop_title {
    padding-top: 0.8rem;
    font-size: 0.48rem;
    line-height: 0.6rem;
  }
  .landingpage_drop_box{
    padding: 0 0.4rem 1.17rem 0.5rem;
  }
  .landingpage_drop_content {
    margin-top: 0.84rem;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .landingpage_drop_div {
    width: 2.76rem;
    height: auto;
  }
  .landingpage_drop_div2 {
    width: 2.76rem;
    height: auto;
    margin-top: 1.15rem;
  }
  .landingpage_drop_font {
    font-size: 0.38rem;
    line-height: 0.28rem;
    margin: 0 0 0.26rem 0;
  }
  .landingpage_drop_font2 {
    font-size: 0.28rem;
    line-height: 0.24rem;
  }
  .landingpage_drop_box {
    width: 100%;
  }

  .landingpage_img {
    height: auto;
  }
  .landingpage_img_box {
    width: 100%;
    padding: 0 0.48rem 1rem 0.48rem;
  }
  .landingpage_img_title {
    padding: 0.8rem 0 0.66rem 0;
    line-height: 0.6rem;
    font-size: 0.48rem;
  }
  .landingpage_img_box img {
    width: 100%;
    height: auto;
  }
  .landingpage_sign {
    height: auto;
  }
  .landingpage_sign_box {
    width: 100%;
    padding: 0 0.48rem 1rem 0.48rem;
  }
  .landingpage_sign_title {
    padding-top: 0.8rem;
  }
  .landingpage_sign_title1 {
    font-size: 0.48rem;
    line-height: 0.6rem;
  }
  .landingpage_sign_title2 {
    margin: 0.8rem 0 0.4rem 0;
    font-size: 0.28rem;
    line-height: 0.42rem;
  }
  .landingpage_sign_title3 {
    width: 100%;
    height: 0.96rem;
    line-height: 0.96rem;
    box-shadow: 0px 0.09px 0.12px 0px rgba(252, 83, 34, 0.1);
    font-size: 0.24rem;
  }
  .landingpage_sign_title5 {
    font-size: 0.28rem;
    line-height: 0.3rem;
    font-weight: bold;
  }
  .landingpage_sign_title4 {
    font-size: 0.28rem;
    line-height: 0.42rem;
  }
  .landingpage_soulutions {
    height: auto;
  }
  .landingpage_soulutions_box {
    width: 100%;
    padding: 0.8rem 0.48rem 0.92rem 0.48rem;
  }
  .landingpage_soulutions_title {
    margin-bottom: 0.8rem;
    padding: 0;
  }
  .landingpage_soulutions_title1 {
    font-size: 0.48rem;
    line-height: 0.6rem;
    width: auto;
  }
  .landingpage_soulutions_title2 {
    width: auto;
    font-size: 0.28rem;
    line-height: 0.42rem;
  }
  .landingpage_soulutions_center {
    display: initial;
  }
  .landingpage_soulutions_content img {
    width: 1rem;
    height: 1rem;
  }
  .landingpage_soulutions_content2 img {
    width: 1rem;
    height: 1rem;
  }
  .landingpage_soulutions_content_right2 {
    font-size: 0.26rem;
    line-height: 0.31rem;
  }
  .landingpage_soulutions_content_right3 {
    font-size: 0.2rem;
    line-height: 0.24rem;
    margin-top: 0.2rem;
    width: auto;
    height: auto;
  }
  .landingpage_soulutions_content {
    margin-top: 0.75rem;
  }
  .landingpage_soulutions_content2 {
    margin-top: 0.75rem;
  }
  .landingpage_service {
    height: auto;
  }
  .landingpage_service_box {
    width: 100%;
    padding: 0.8rem 0.48rem 0.9rem 0.48rem;
  }
  .landingpage_service_box_title {
    font-size: 0.48rem;
    line-height: 0.6rem;
    width: auto;
    height: auto;
  }
  .landingpage_soulutions_content_right4 {
    margin-top: 0.24rem;
    width: auto;
    height: auto;
    font-size: 0.2rem;
    line-height: 0.24rem;
  }
  .landingpage_soulutions_content_right4_li {
    margin-bottom: 0.15rem;
  }
  .landingpage_soulutions_content_right {
    margin-left: 0.13rem;
    margin-top: .1rem;
  }
  .landingpage_soulutions_bottom {
    font-size: 0.2rem;
    line-height: 0.36rem;
    margin-top: 0.43rem;
  }
  .landingpage_heard {
    height: auto;
    padding: 0;
  }
  .landingpage_heard_box {
    width: 100%;
    padding: 0.8rem 0.48rem 1rem 0.48rem;
  }
  .landingpage_heard_title {
    font-size: 0.48rem;
    line-height: 0.58rem;
  }
  .landingpage_heard_center {
    margin-top: 0.8rem;
    flex-direction: column-reverse;
  }
  .title_icon landingpage_heard_content2_icon {
    margin-bottom: 0.33rem;
  }
  .landingpage_heard_content2 {
    margin-left: 0;
  }
  .landingpage_heard_content2_line {
    font-size: 0.44rem;
    line-height: 0.6rem;
  }
  .landingpage_heard_content2_line2 {
    margin: 0.4rem 0 0.8rem 0;
    font-size: 0.3rem;
    line-height: 0.42rem;
    text-align: center;
  }
  .landingpage_heard_content2_line3 {
    font-size: 0.28rem;
    line-height: 0.42rem;
    text-align: center;
  }
  .landingpage_heard_content2_line4 {
    width: 100%;
    height: 0.96rem;
    margin: 0.4rem 0;
    border-radius: 0.08rem;
    font-size: 0.28rem;
    line-height: 0.96rem;
    font-weight: bold;
  }
  .landingpage_heard_content2_line5 {
    font-size: 0.28rem;
    line-height: 0.42rem;
    text-align: center;
  }
  .landingpage_heard_content {
    width: 100%;
    margin-top: 0.73rem;
  }
  .landingpage_heard_content img {
    width: 6.29rem;
    height: 3.93rem;
    display: block;
    margin: auto;
  }
  .landingpage_heard_content_div {
    margin-top: 0.46rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .landingpage_heard_content_div img {
    margin-left: 0.1rem;
    width: 0.2rem;
    height: 0.2rem;
  }
  .landingpage_heard_content_div span {
    font-size: 0.28rem;
    line-height: 0.42rem;
  }
  .landingpage_questions {
    height: auto;
    padding: 0;
  }
  .landingpage_questions_box {
    width: 100%;
    padding: 0.8rem 0.48rem 0.2rem 0.48rem;
  }
  .landingpage_questions_title {
    font-size: 0.48rem;
    line-height: 0.55rem;
    margin-bottom: 0.6rem;
  }
  .landingpage_questions_content img {
    width: 0.28rem;
    height: 0.28rem;
  }
  .landingpage_questions_content_right {
    margin-left: 0.15rem;
    margin-bottom: 0.8rem;
  }
  .landingpage_questions_content_right_line {
    font-size: 0.3rem;
    line-height: 0.36rem;
    margin-bottom: 0.15rem;
  }
  .landingpage_questions_content_right_line2 {
    font-size: 0.24rem;
    line-height: 0.3rem;
  }
  .landingpage_bottom {
    height: auto;
    padding: 0;
  }
  .landingpage_bottom_box {
    width: 100%;
    padding: 0.8rem 0.48rem 1rem 0.48rem;
  }
  .landingpage_bottom_title {
    width: auto;
    font-size: 0.44rem;
    line-height: 0.6rem;
  }
  .landingpage_bottom_title2 {
    font-size: 0.28rem;
    line-height: 0.42rem;
    margin: 0.8rem 0 0 0;
  }
  .landingpage_banner {
    width: 100%;
    height: 0.66rem;
    font-size: 0.2rem;
    line-height: 0.66rem;
  }
  .home_what_box {
    width: 100%;
    padding: 0.67rem 0.46rem 0.37rem;
  }
  .home_title {
    padding: 0.67rem 0 0.68rem;
    font-size: 0.48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.48rem;
  }
  .home_what_line {
    flex-direction: column;
    height: auto;
    padding-bottom: 0.77rem;
  }
  .home_what_line_text {
    width: 100%;
    margin: 0 !important;
  }
  .home_what_line_text_symbol {
    margin: 0 0 0.3rem;
  }
  .home_what_line_text_title {
    margin-bottom: 0.2rem;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
  }
  .home_what_line_text_content {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.36rem;
    margin-bottom: 0.4rem;
  }
  .home_what_line_img {
    margin: 0 !important;
    background: rgba(252, 83, 34, 0.12);
    height: 3.96rem;
    border-radius: 0.2rem;
    width: 100%;
    padding: 0.27rem;
  }
  .home_what_line_img img {
    width: 100%;
    height: 100%;
    margin: 0;
  }
  .home_what_line2 {
    flex-direction: column-reverse;
  }
  .home_what_bottom{
  padding: .43rem 0 .8rem 0;
}
.home_what_bottom_title1{
 font-size: .48rem;
font-weight: bold;
line-height: .58rem;
}
.home_what_bottom_title2{
font-size: .28rem;
line-height: .26rem;
}
.home_what_bottom_platform{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: .48rem 0 .32rem 0;
}
.home_what_bottom_img1{
width: 3.03rem;
height: 1.53rem;
border-radius: .08rem;
text-align: center;
line-height: 1.53rem;
}
.home_what_bottom_img1_img1{
width: 1.7rem;
height: .61rem;
}
.home_what_bottom_img1_img2{
width: 2.14rem;
height: .48rem;
}
.home_what_bottom_img2{
width: 3.03rem;
height: 1.53rem;
border-radius: .08rem;
text-align: center;
line-height: 1.53rem;
position: relative;
margin-top: .2rem;
}
.home_what_bottom_img2_img1{
width: 1.65rem;
height: .56rem;
}
.home_what_bottom_img2_img2{
width: 2.07rem;
height: .42rem;
}
.home_what_bottom_img2_div{
width: auto;
padding: 0 .12rem;
height: .28rem;
font-size: .16rem;
line-height: .28rem;
border-radius: .08rem 0px .08rem 0px;
opacity: 0.4;
position: absolute;
top: 0;
left: 0;
}
  .home_say {
    padding: 0.8rem 0.48rem 1rem 0.48rem;
    height: auto;
  }
  .home_say_box {
    width: 100%;
  }
  .home_say_title {
    margin-bottom: 0.39rem;
    font-size: 0.48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.6rem;
    margin: 0 auto 0.39rem;
    padding: 0 0.1rem;
  }
  .home_say_content_line {
    overflow: auto;
  }
  .home_say_content_item {
    width: 5.75rem;
    height: 5.86rem;
    padding: 0.6rem 0.48rem 0.62rem;
  }
  .home_say_content_top img {
    width: 0.72rem;
    height: 0.72rem;
  }
  .home_say_content_top em {
    width: 0.02rem;
    height: 0.24rem;
    background: #8d919b;
  }
  .home_say_content_top_name {
    margin: 0 0.24rem 0 0.42rem;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
  }
  .home_say_content_top_country {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.42rem;
    margin-left: 0.24rem;
  }
  .home_say_content_text {
    margin: 0.31rem 0 0;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.36rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 10;
    overflow: hidden;
  }
  .home_say_left,
  .home_say_right {
    display: none;
  }
  .home_Partnership {
    width: 100%;
    padding: 0.61rem 0.46rem 1.15rem;
  }
  /* .home_title{
    margin-bottom: .61rem;
    font-size: .46rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: .58rem;
  } */
  .home_Partnership_imgs {
    padding: 0;
  }
  .home_Partnership_imgs > img {
    width: 1.27rem;
    height: 0.46rem;
  }
}
</style>
<style>
.top_bg_h {
  width: 1243px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.55;
  border: 120px solid #f6f7fa;
  position: absolute;
  top: 87px;
  left: 0;
}
@media (max-width: 767px) {
  .top_bg_h {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/landingpage.vue